/** Raumleiste, Hinweiszeile, Toasts. */
import { Link } from 'react-router-dom'

import { useLang } from '../lang'
import type { LiveState } from '../lib/live'
import type { RoomState } from '../lib/types'
import type { Toast } from '../lib/store'

export function RoomBar({
  room,
  pulse,
  marks2min,
}: {
  room: RoomState
  pulse: number[]
  marks2min: number
}) {
  const { t } = useLang()
  const peak = Math.max(1, ...pulse)
  return (
    <div className="bar">
      <div className="row row--between">
        <div style={{ minWidth: 0 }}>
          <div className="kicker">
            {room.status === 'running' ? <span className="tag tag--live">live</span> : <span className="tag">{room.status}</span>}
          </div>
          <div style={{ fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {room.title}
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div className="pts">{room.players}</div>
          <div className="kicker">{t('room.players')}</div>
        </div>
      </div>
      <div className="row" style={{ marginTop: 6, gap: 8 }}>
        <div className="pulse" style={{ flex: 1 }} aria-hidden="true">
          {pulse.map((n, i) => (
            <i key={i} style={{ height: `${Math.max(8, (n / peak) * 100)}%` }} />
          ))}
        </div>
        <span className="kicker" aria-label={`${marks2min} ${t('room.marks2min')}`}>
          {marks2min} · 2′
        </span>
      </div>
    </div>
  )
}

export function LiveNote({ state, queued }: { state: LiveState; queued: number }) {
  const { t } = useLang()
  if (state === 'live' && queued === 0) return null
  const text =
    state === 'offline'
      ? t('live.offline')
      : queued > 0
        ? t('live.queued', { n: queued })
        : t('live.polling')
  return (
    <div className="offline" role="status">
      {text}
    </div>
  )
}

export function Toasts({ toasts, onDismiss }: { toasts: Toast[]; onDismiss: (id: number) => void }) {
  if (!toasts.length) return null
  const top = toasts[toasts.length - 1]
  if (!top) return null
  return (
    <div className="toast" role="status" onClick={() => onDismiss(top.id)}>
      {top.text}
    </div>
  )
}

export function Header({ right }: { right?: React.ReactNode }) {
  const { t } = useLang()
  return (
    <div className="row row--between" style={{ marginBottom: 12 }}>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <h1 style={{ fontSize: 26 }}>
          BS Bingo<span className="dot">.</span>
        </h1>
      </Link>
      <div className="row">{right}</div>
      <span className="sr-only">{t('app.tagline')}</span>
    </div>
  )
}
